export default __webpack_public_path__ + "static/media/Authorandartist.717d889d.txt";